export default __webpack_public_path__ + "static/media/video-not-available.183681a1.svg";